import { ref, update } from "firebase/database";
import { db } from "../firebaseConfig";
import { ItemInfo } from "../../models/item";

// Updates all fields of an item in the Realtime Database
export const updateItem = async (
	itemId: string,
	updatedItem: ItemInfo
): Promise<void> => {
	const itemRef = ref(db, `items/${itemId}`);
	await update(itemRef, { ...updatedItem });
};
